import { type AxiosError } from 'axios';

import { getAuthHeader } from '@/entities/auth';
import { Api } from '@/shared/api/types/schema';

import { getLocalStorageItem, removeLocalStorageItem } from '../../utils';

const api = new Api({
  baseURL: `${import.meta.env.VITE_API_URL}`,
  securityWorker() {
    return {
      headers: {
        ...getAuthHeader(),
      },
    };
  },
});

api.instance.interceptors.request.use(
  (config) => {
    const token: string | null = getLocalStorageItem('token');
    if (token) {
      // Используем метод set для работы с AxiosHeaders
      config.headers?.set('Authorization', `Bearer ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export const redirectUrl = encodeURIComponent(window.location.href);

export const authUrl = `https://flowai.ru/auth/sign-in?redirect=${redirectUrl}/`;

// Обработка ошибок ответа
api.instance.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const status = error.response?.status;
    const proxyAuthTarget = error.response?.headers['proxy-auth'];

    // Обработка 401 ошибки
    if (status === 401) {
      window.open(authUrl, '_self');
      if (proxyAuthTarget === 'esia') {
        window.open(authUrl, '_self');
        return;
      }

      try {
        removeLocalStorageItem('token');

        if (error.config) {
          // Повторный запрос с обновленным токеном
          return api.instance.request(error.config);
        }
      } catch (refreshError) {
        removeLocalStorageItem('token');
        throw refreshError;
      }
    }

    // Обработка других ошибок (например, редирект при 403)
    // if (status === 403) {
    //   window.location.href = '#/*';
    // }

    return Promise.reject(error);
  },
);

// api.instance.interceptors.response.use(
//     (response) => response,
//     async (error) => {
//       const originalRequest = error.config;
//
//       if (
//           error.response?.status === 401 &&
//           !originalRequest._retry &&
//           originalRequest.url !== '/token/refresh'
//       ) {
//         originalRequest._retry = true;
//
//         try {
//           const refreshToken = localStorage.getItem('refreshToken');
//           if (!refreshToken) {
//             throw new Error('Нет токена обновления');
//           }
//
//           const response = await axios.post(`${API_URL}/token/refresh`, {
//             refresh_token: refreshToken,
//           });
//
//           const { access_token, refresh_token } = response.data;
//           localStorage.setItem('token', access_token);
//           localStorage.setItem('refreshToken', refresh_token);
//
//           originalRequest.headers.Authorization = `Bearer ${access_token}`;
//           return api.instance(originalRequest);
//         } catch (refreshError) {
//           // Удаляем токены, если произошла ошибка при обновлении
//           localStorage.removeItem('token');
//           localStorage.removeItem('refreshToken');
//           return Promise.reject(refreshError);
//         }
//       }
//
//       // Если ошибка не 401 или если запрос был уже повторен, отклоняем
//       return Promise.reject(error);
//     }
// );

export { api };
